import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { roundValue } from 'common/utils/utils';
import moment from 'moment';
import { SIZES } from 'common/constants/sizes';

const StyledTooltip = styled.div`
  background: ${getColor('white')};
  font-size: ${SIZES.medium};
  padding: 0.5rem;
`;

const Tooltip = ({ event, forecast, selectedFilterSet }) => {
  const weekDate = moment(event.point.week).format('MMMM D');
  const frequency = roundValue(event.point.frequency, 0);
  const probabilityP = roundValue(event.point.totalProbability * 100, 1);
  const scopeName = selectedFilterSet?.name || 'this scope';

  return (
    <StyledTooltip>
      The week of {weekDate} emerged as a completion date in {frequency}/
      {forecast.totalSimulations} simulation instances.
      <br />
      The probability of completing "{scopeName}" on that week is {probabilityP}
      %
    </StyledTooltip>
  );
};

export default Tooltip;
